<template>
  <div class="pageBox">
    <span class="firstPage" style="margin: 0;" @click="gotoFirstPage">首页</span>
    <el-pagination
      class="pagination"
      :background="background"
      :current-page.sync="currentPages"
      :page-size.sync="pageSize"
      :layout="layout"
      :pager-count="pagerCount"
      :total="total"
      v-bind="$attrs"
      @current-change="handleCurrentChange"
      prev-text="上一页"
      next-text="下一页"
    ></el-pagination>
    <span class="lastPage" @click="gotoLastPage">尾页</span>
    <ul class="pull-right">
      <li class="display_text">
        <span>
          第
          <i>{{pageNum}}</i>
          页 / 共{{pageCount}}页
        </span>
      </li>
      <li class="display_text">
        <span> 共 {{total}} 条数据 </span>
      </li>
      <li class="pageCurrent">
        <span>跳转到</span>
        <span>
          <el-input v-model="page" @keyup.enter.native="gotoPageNum"></el-input>
        </span>
      </li>
      <li @click="gotoPageNum">GO</li>
    </ul>
  </div>
</template>
  
  <script>
export default {
  name: "Pagination",
  data(){
    return{
        page:1
    }
  },
  props: {
    total: {
      required: true,
      type: Number,
    },
    pageNum: {
      type: Number,
      default: 1,
    },
    lineSize: {
      type: Number,
      default: 10,
    },
    // 移动端页码按钮的数量端默认值5
    pagerCount: {
      type: Number,
      default: document.body.clientWidth < 992 ? 5 : 7,
    },
    layout: {
      type: String,
    //   default: 'prev, pager, next, total, jumper'
      default: "->, prev, pager, next",
    },
    background: {
      type: Boolean,
      default: true,
    },
  },
  watch:{
    pageNum(newVal,oldVal){
        this.page = newVal
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.lineSize);
    },
    currentPages: {
      get() {
        return this.pageNum;
      },
      set(val) {
        this.$emit("update:pageNum", val);
      },
    },
    pageSize: {
      get() {
        return this.lineSize;
      },
      set(val) {
        this.$emit("update:lineSize", val);
      },
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('update:pageNum', val);
      this.$emit("pagination", { pageNum: val, lineSize: this.lineSize });
    },
    gotoFirstPage(){
      if (this.pageNum > 1) {
        this.handleCurrentChange(1);
      }
    },
    gotoLastPage(){
      if (this.pageNum < this.pageCount) {
        this.handleCurrentChange(this.pageCount);
      }
    },
    gotoPageNum(){
        this.handleCurrentChange(this.page);
    },
  },
};
</script>
  
  <style scoped lang="less">

.pageBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  // margin-top: 30px;
  // margin-bottom: 30px;
}
.pageBox > span {
  display: inline-block;
  font-size: 12px;
  color: #666666;
  padding: 0 12px;
  margin: 0 5px;
  border: 1px solid #f4f4f5;
  border-radius: 3px;
  background-color: white;
  line-height: 30px;
  cursor: pointer;
}
.pageBox .pull-right {
  display: flex;
}
.pageBox .pull-right li {
  padding: 0 5px;
  margin: 0 5px;
  font-size: 12px;
  color: #666666;
  height: 30px;
  line-height: 30px;
}
.pageBox .pull-right li i {
  font-style: normal;
  color: #bb0015;
}
.pull-right .pageCurrent span {
  margin-right: 2px;
}
.pull-right .pageCurrent /deep/.el-input__inner {
  width: 39px;
  height: 30px;
  padding: 0;
  text-align: center;
  border: 1px solid #f4f4f5;
}
.pull-right .pageCurrent /deep/.el-input {
  width: 39px;
  height: 30px;
}
.pull-right li:last-child {
  border: 1px solid #f4f4f5;
  border-radius: 3px;
  background-color: white;
  margin: 0;
  padding: 0 15px;
  cursor: pointer;
}

.pagination {
  display: flex;
  justify-content: center; //居中
  font-size: 11px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination span:not([class*="suffix"]) {
  font-size: 12px;
  color: #666666;
}
::v-deep .el-pagination.is-background .btn-prev {
  background: #ffffff !important;
  border: 1px solid #f4f4f5;
  width: 70px;
}
::v-deep .el-pagination.is-background .btn-next {
  background: #ffffff !important;
  border: 1px solid #f4f4f5;
  width: 70px;
}
::v-deep .el-pagination.is-background .el-pager li {
  color: #666666;
  // border: 1px solid #f4f4f5;
  min-width: 28px;
  height: 30px;
  line-height: 30px;
  border-radius: 3px;
}
::v-deep .el-pagination.is-background .btn-prev,
::v-deep .el-pagination.is-background .btn-next,
::v-deep .el-pagination.is-background .el-pager li {
  background-color: transparent;
  height: 30px;
}
::v-deep .el-pagination button,
.el-pagination span:not {
  height: 30px;
  line-height: 30px;
}
.active {
  color: #bb0015;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #000;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #bb0015 !important;
}

/deep/.el-pagination__editor.el-input .el-input__inner {
  height: 30px !important;
}
.pagination /deep/.el-select-dropdown__item.selected {
  color: #bb0015;
  font-weight: 700;
}
/deep/.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: #bb0015;
}
</style>
    